import { axiosInstance } from '../axios';
import { Bank } from '../subscription/Subscription.model';
import { asyncGet } from '../utils';
import { City, Contract, Country, Department, Housing, Marital, Profession, Sector } from './Referential.model';
const referentialPath = `referential`;

export function referentialApi() {
  return Object.freeze({
    getMaritals: (): Promise<Marital[]> => asyncGet(axiosInstance(), `${referentialPath}/maritals`),
    getCountries: (): Promise<Country[]> => asyncGet(axiosInstance(), `${referentialPath}/countries`),
    getDepartments: (): Promise<Department[]> => asyncGet(axiosInstance(), `${referentialPath}/departments`),
    getDepartementCities: (departmentCode: string): Promise<City[]> =>
      asyncGet(axiosInstance(), `${referentialPath}/departments/${departmentCode}/cities`),
    getCitiesByZipCode: (zipCode: string, geoLoc: string): Promise<City[]> =>
      asyncGet(axiosInstance(), `${referentialPath}/localities/${zipCode}?geoLoc=${geoLoc}`),
    getHousings: (): Promise<Housing[]> => asyncGet(axiosInstance(), `${referentialPath}/residentials`),
    getContracts: (): Promise<Contract[]> => asyncGet(axiosInstance(), `${referentialPath}/contracts`),
    getSectors: (): Promise<Sector[]> => asyncGet(axiosInstance(), `${referentialPath}/sectors`),
    getProfessionsBySectorCode: (sectorCode: string): Promise<Profession[]> =>
      asyncGet(axiosInstance(), `${referentialPath}/sectors/${sectorCode}/professions`),
    getContractsBySectorAndProfession: (sectorCode: string, professionCode: string): Promise<Contract[]> =>
      asyncGet(axiosInstance(), `${referentialPath}/sectors/${sectorCode}/professions/${professionCode}/contracts`),
    getBanks: (): Promise<Bank[]> => asyncGet(axiosInstance(), `${referentialPath}/banks`),
  });
}
